"use strict";

exports.__esModule = true;
var _ResetPasswordScreen = require("./ResetPasswordScreen");
Object.keys(_ResetPasswordScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ResetPasswordScreen[key]) return;
  exports[key] = _ResetPasswordScreen[key];
});
var _ForgotPasswordScreen = require("./ForgotPasswordScreen");
Object.keys(_ForgotPasswordScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ForgotPasswordScreen[key]) return;
  exports[key] = _ForgotPasswordScreen[key];
});
var _ForgotPasswordRoutes = require("./ForgotPasswordRoutes");
Object.keys(_ForgotPasswordRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ForgotPasswordRoutes[key]) return;
  exports[key] = _ForgotPasswordRoutes[key];
});
var _ResetPasswordRoutes = require("./ResetPasswordRoutes");
Object.keys(_ResetPasswordRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ResetPasswordRoutes[key]) return;
  exports[key] = _ResetPasswordRoutes[key];
});